export const MASTER_API_URL = {
  MASTER: 'v1/master/{{type}}',
  COUNTRY_CODE: 'country/code-lookup',
  COUNTRY: 'country/lookup',
  TIMEZONE: 'timezone/lookup',
  ALL_STATE: 'state/lookup',
  STATE: 'state/lookup-by-country-id',
  Business: 'business/search',
  TRAINING_LICENCE: 'training-licence/lookup',
  TASK_GROUP_AREA: 'task-group/area-lookup',
  TASK_GROUP_LOCATION: 'task-group/location-lookup',
  CURRENCY_LOOKUP: 'country/currency-lookup',
  ERROR: 'client-side-error',
};
